module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/lion-english.fb3b054a.jpg";